import script from "./PricingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PricingCard.vue?vue&type=script&setup=true&lang=js"

import "./PricingCard.vue?vue&type=style&index=0&id=a3f4373a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3f4373a"]])

export default __exports__